// //对错号，正确答案试题详情
<template>
    <div>
        <template>
            <div class="wrap"
                 v-if="questions.length > 0">
                <!-- <div class="tip">共{{ num }}题( 答对<span>{{num - wrongNum}}</span>题, 答错<span>{{wrongNum}}</span>题 )</div> -->
                <div class="exercises stu_dowork_line"
                     v-for="(data,index) in questions">
                    <span class="quest_num">第{{index+1}}题</span>
                    <div class="quest_title clearfix"
                         v-if="data.asks.length>1">
                        <span class="tit_num">（{{index+1}}）</span>
                        <span class="title"
                              v-if="data.type!=8"><span v-html="data.content"></span></span>
                        <p class="title"
                           v-if="data.type==8 && data.article_title"><span v-html="data.article_title"></span></p>
                        <p class="title"
                           v-if="data.type==8"><span v-html="data.article_text"></span></p>

                        <div class="img-wrap"
                             v-if="data.image && data.image.url"><img :src="data.image" /></div>
                    </div>
                    <div class="quest_con"
                         v-for="ask,inx in data.asks">
                        <!-- 选择题 -->
                        <div v-if="ask.type==1||ask.type==8||ask.type==7">
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <choice :ask='ask'
                                    :type="ask.type"
                                    :checked="true"
                                    :myColor='true'
                                    :number="data.asks.length>1?0:index+1"
                                    :mystatus="1"
                                    :status="ask.user_result==1?0:1"></choice>
                        </div>
                        <!-- 填空 -->
                        <div v-if='ask.type == 2'>
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <blanks :ask='ask'
                                    :askLength='data.asks.length'
                                    :checked="true"
                                    :myColor='true'
                                    :number="data.asks.length>1?0:index+1"></blanks>
                        </div>
                        <!-- 主观题 -->
                        <div v-if='ask.type == 3'>
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <!--<subjective :ask='data.asks' :index='inx' :question='ask' :askLength='data.asks.length'></subjective>-->
                        </div>
                        <!-- 连线题 -->
                        <div class="line"
                             v-if="ask.type==4">
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <lines :ask='ask'
                                   :sheet="ask.user_answer"
                                   :origin='1'
                                   :onlyshow='true'
                                   :result='1'
                                   :checked="true"
                                   :myColor='true'
                                   :number="data.asks.length>1?0:index+1"></lines>
                        </div>
                        <!-- 排序题 -->
                        <div class="line"
                             v-if="ask.type==5">
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <makes :ask='ask'
                                   :is_answer="true"
                                   :type='ask.type'
                                   :checked="true"
                                   :myColor='true'
                                   :number="data.asks.length>1?0:index+1"></makes>
                        </div>
                        <!-- 断句题 -->
                        <div v-if="ask.type==6">
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <sentence :ask='ask'
                                      :myColor='true'
                                      :checked="true"
                                      :number="data.asks.length>1?0:index+1"></sentence>
                        </div>
                        <div class='answer-wrap'
                             v-if='ask.type!=7'>
                            <div class="user">
                                <div class="user-answer">【正确答案】
                                    <div class="line"
                                         v-if="ask.type==4">
                                        <lines :ask='ask'
                                               :sheet="ask.right_answer"
                                               :origin='1'
                                               :onlyshow='true'
                                               :result='0'
                                               :tag="1"></lines>
                                    </div>
                                    <div v-else-if=" ask.type == 5">
                                        <!-- <make :now ='item' :allnum = 'question.asks.length' :num ='question.num' :aindex="index"></make> -->
                                        <div class="contact_blank">
                                            <span class="blank"
                                                  v-for="num in ask.right_answer"
                                                  v-html="num"
                                                  v-if="num">{{ask.num}}</span>
                                            <!-- <span class="blank" v-for="num in ask.user_answer" v-html="ask.right_answer[num]" v-if="ask.right_answer[num]">{{ask.right_answer[num]}}</span> -->
                                        </div>
                                    </div>
                                    <div v-else-if=" ask.type == 6">
                                        <div class="contact_blank">
                                            <span v-html="ask.point"></span>
                                        </div>
                                    </div>
                                    <div v-else-if=" ask.type == 2">
                                        <!-- <make :now ='item' :allnum = 'question.asks.length' :num ='question.num' :aindex="index"></make> -->
                                        <div class="kong_box">
                                            <span class="kong_span"
                                                  v-for="answer in ask.right_answer"
                                                  v-html="answer">{{answer}}</span>
                                        </div>
                                    </div>
                                    <template v-else>
                                        <span v-for="right in ask.choice_answer"
                                              v-html="right.option"></span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nowork"
                 v-else>
                <noResouse :text="'暂无试题'"></noResouse>
            </div>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
// import loadingS from 'COMPONENTS/common/loading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';
import choice from './module/result_choose.vue';  //选择题
import blanks from './module/result_fill.vue'; //填空题
import lines from './module/result_line.vue';     //连线题
import sentence from './module/result_sentence.vue';//断句题
import makes from './module/result_make.vue';//排序题
export default {
    props: ['questions', 'sid'],
    data () {
        return {
        }
    },
    computed: {},
    methods: {
    },
    created () {
    },
    destroyed () {
    },
    components: {
        noResouse,
        sentence,
        choice,
        blanks,
        lines,
        makes
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
// @import "./src/assets/scss/common/_mixin";

[v-cloak] {
    display: none;
}

// #classdetailstu {
//   min-height: 100vh;
// }
.wrap {
    padding-bottom: 96px / $ppr;
    font-size: 28px / $ppr;
}

.tip {
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    font-size: 30px / $ppr;
    background-color: #fff;
    padding: 0 24px / $ppr;
    margin-bottom: 24px / $ppr;
    span {
        color: #ff6600;
    }
}
.bottom_btn {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 96px / $ppr;
    width: 100%;
    z-index: 8;
    div {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        background: #5e89ef;
        text-align: center;
        font-size: 30px / $ppr;
        color: #fff;
        line-height: 96px / $ppr;
    }
}
.answer-wrap {
    background-color: #fff;
    border-top: 1px / $ppr solid #dcdcdc;
    .user {
        color: #999;
        font-size: 30px / $ppr;
        .user-answer {
            padding: 35px / $ppr 0;
        }
    }
}

.quest_title {
    position: relative;
    padding: 24px / $ppr;
    line-height: 46px / $ppr;
    font-size: 30px / $ppr;
    color: #333;
    background: #fff;
    p:first-child {
        padding-left: 48px / $ppr;
    }
}
.quest_title > span {
    float: left;
}
.quest_con {
    position: relative;
    margin-bottom: 24px / $ppr;
}

.nowork {
    color: #aaa;
    text-align: center;
    margin-top: 304px / $ppr;
}

.judgeicon {
    position: absolute;
    right: 24px / $ppr;
    top: -40px / $ppr;
    z-index: 2;

    //background-color: #21BF63;
}

.dui {
    width: 35px / $ppr;
    height: 36px / $ppr;
    background-image: url("img/right.png");
    background-size: cover;
}

.cuo {
    width: 33px / $ppr;
    height: 36px / $ppr;
    background-image: url("img/wrong.png");
    background-size: cover;
}

.exercises {
    background-color: #fff;
    position: relative;
    width: 600px / $ppr;
    padding: 30px / $ppr;
    margin: 0 auto 30px / $ppr;
    border-radius: 16px / $ppr;
    line-height: 46px / $ppr;
    margin-top: 30px / $ppr;
}
.quest_con /deep/ .choose {
    margin-top: 0 !important;
}
.kong_span {
    display: inline-block;
    line-height: 45px / $ppr;
    padding: 20px / $ppr 15px / $ppr 10px / $ppr 0;
}
.blank {
    display: inline-block;
    line-height: 45px / $ppr;
    padding: 20px / $ppr 20px / $ppr 0;
    border-bottom: 1px / $ppr solid #dcdcdc;
    margin-right: 20px / $ppr;
}
.quest_num {
    font-size: 28px / $ppr;
    font-weight: bold;
    line-height: 48px / $ppr;
}
</style>
